module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-pad-y-1"
  }, [_c('div', {
    staticClass: "c-page--container c-marg--before-footer u-relative"
  }, [_c('header', {
    staticClass: "c-article__head u-block u-relative u-marg-b-xxl u-marg-t-xxxl@md u-marg-b-lg@md"
  }, [_c('div', {
    staticClass: "u-marg-b-xs"
  }, [_c('div', {
    staticClass: "u-valign-middle u-color--gray-light t-text--sm t-lspacing--md u-uppercase u-inline-block u-marg-l-w1of9 u-w5of9 u-marg-l-0@md u-fit-w@md",
    domProps: {
      "innerHTML": _vm._s(_vm.formatDate(_vm.contentPage.date))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-inline-block u-w2of9 u-align-right u-hide@md",
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.taxonomies.words.share)
    }
  })]), _vm._v(" "), _c('div', [_c('h1', {
    staticClass: "t-h4 u-uppercase u-inline-block u-marg-l-w1of9 u-w5of9 u-valign-top u-marg-l-0@md u-fit-w@md"
  }, [_vm._v(_vm._s(_vm.contentPage.title))]), _vm._v(" "), _c('div', {
    staticClass: "u-inline-block u-w2of9 u-align-right u-valign-top u-hide@md"
  }, [_c('app-btn-share', {
    attrs: {
      "type": "mail",
      "url": _vm.currentURL,
      "title": _vm.contentPage.title,
      "content": _vm.contentPage.share.mail,
      "size": "small"
    }
  }), _vm._v(" "), _c('app-btn-share', {
    staticClass: "c-news-share-icon",
    attrs: {
      "type": "facebook",
      "url": _vm.currentURL,
      "title": _vm.contentPage.title,
      "content": _vm.contentPage.share.facebook,
      "size": "small"
    }
  }), _vm._v(" "), _c('app-btn-share', {
    staticClass: "c-news-share-icon",
    attrs: {
      "type": "twitter",
      "url": _vm.currentURL,
      "title": _vm.contentPage.title,
      "content": _vm.contentPage.share.twitter,
      "size": "small"
    }
  })], 1)])]), _vm._v(" "), _c('app-youtube', {
    staticClass: "u-fit-w",
    attrs: {
      "id": _vm.contentPage.youtubeId
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a8498ee"}!./src/scripts/components/page-video-player/template.html
// module id = 896
// module chunks = 0